export const COOKIE_NOTICE_STORAGE_KEY = "lemonade-cookie-notice-dismissed";

/** Bump when the cookie inventory changes materially, so everyone sees the notice again. */
export const COOKIE_NOTICE_VERSION = "1";

/* Private mode and blocked site data make localStorage throw; the notice then
 * shows each visit and closes for the page's lifetime. */
export const isCookieNoticeDismissed = (): boolean => {
  try {
    return window.localStorage.getItem(COOKIE_NOTICE_STORAGE_KEY) === COOKIE_NOTICE_VERSION;
  } catch {
    return false;
  }
};

export const markCookieNoticeDismissed = (): void => {
  try {
    window.localStorage.setItem(COOKIE_NOTICE_STORAGE_KEY, COOKIE_NOTICE_VERSION);
  } catch {
    // Blocked storage only means the notice returns on the next visit.
  }
};
